module.exports = __webpack_public_path__ + "static/media/me@1800x1014.96ec7812.jpg";